import { withProps } from 'recompose';
import Item from './Item';
import { formatCount } from '../../utils/format';

const CountItem = withProps(({ value }) => ({ value: formatCount(value) }))(Item);

export default CountItem;
